module.exports = __webpack_public_path__ + "img/ic-redirect.1f91c379.svg";